(() => {
  'use strict';
  if (window.__MYX_DRAWING_LOADER__) return;
  window.__MYX_DRAWING_LOADER__=true;
  const assets=window.__MYX_DRAWING_ASSETS__||{}, mobile=matchMedia('(max-width:999px)');
  let host=null, review=null, pending=null, generation=0, loaded=false, wasVisible=false;
  const style=document.createElement('style');
  style.textContent='.myx-drawing-column{min-width:0;display:grid;gap:22px;align-content:start}.myx-drawing-entry{width:100%;display:flex;align-items:center;justify-content:flex-start;gap:14px;min-height:52px;padding:14px 18px;border:1px solid #39313f;border-radius:14px;background:#141019;color:#eee9f6;font:500 14px inherit;cursor:pointer}.myx-drawing-entry svg{width:19px;height:19px;flex:none}.myx-drawing-entry:hover{border-color:#9d71bf;background:#1e1628}.myx-drawing-host{min-width:0}.myx-drawing-entry:focus-visible{outline:2px solid #be9cff;outline-offset:3px}@media(max-width:999px){.myx-drawing-column{gap:12px}}';
  document.head.append(style);
  function moduleReady(){
    if(window.MaytrixDrawingViewer)return Promise.resolve();
    if(pending)return pending;
    pending=new Promise((resolve,reject)=>{const script=document.createElement('script');script.src=assets.viewer;script.onload=resolve;script.onerror=()=>{pending=null;script.remove();reject(Error('Unable to load drawings'));};document.head.append(script);});
    return pending;
  }
  async function show(open){
    if(!host||!review||review.hidden)return;
    const run=++generation;
    const button=host.querySelector('button');if(button){button.textContent='Preparing your drawings…';button.disabled=true;}
    try {
      await moduleReady();
      if(run!==generation||review.hidden)return;
      window.MaytrixDrawingViewer.mount(host,{assets,mobile:mobile.matches,open,review});loaded=true;
    } catch(error) {if(button){button.textContent='Try loading shop drawings again';button.disabled=false;}}
  }
  function mount(){
    const next=document.getElementById('myx-design-review');
    if(!next||next.hidden||!document.body.classList.contains('myx-review-open')||next.dataset.myxViewerReady!=='1'){wasVisible=false;return;}
    const reopening=!wasVisible;wasVisible=true;
    review=next;
    const viewer=review.querySelector('.myx-review__viewer'),product=review.querySelector('.myx-review__product');
    if(!viewer||!product)return;
    if(!host){
      const column=document.createElement('div');column.className='myx-drawing-column';viewer.before(column);column.append(viewer);
      host=document.createElement('div');host.className='myx-drawing-host';column.append(host);
      const button=document.createElement('button');button.type='button';button.className='myx-drawing-entry';button.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M6 3h8l4 4v14H6zM14 3v5h5M9 12h6M9 16h6"/></svg><span>View your shop drawings</span>';button.setAttribute('aria-haspopup','dialog');button.addEventListener('click',()=>show(true));host.append(button);
    }else if(loaded&&reopening)window.MaytrixDrawingViewer.refresh();
  }
  let timer=0;
  const queue=()=>{if(timer)return;timer=setTimeout(()=>{timer=0;mount();},100);};
  new MutationObserver(records=>{if(records.some(r=>r.target===document.body||r.target.id==='myx-design-review'||[...r.addedNodes].some(n=>n.id==='myx-design-review')))queue();}).observe(document.body,{subtree:true,childList:true,attributes:true,attributeFilter:['class','hidden','data-myx-viewer-ready']});
  mobile.addEventListener('change',()=>{if(loaded)window.MaytrixDrawingViewer.setMobile(mobile.matches);});
  queue();
})();
